import React from "react";
import "../styles/services.css";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import SheildIcon from "../assets/sheild-icon.png";
import LeadsIcon from "../assets/leads-icon.png";
import PolicyIcon from "../assets/policy-icon.png";
import StarIcon from "../assets/star-icon.png";

function Services() {
  return (
    <div className="services-container">
      <div className="services-card-container">
        <div className="services-left-container">
          <h3>SERVICE</h3>
          <h1>What can we do for you?</h1>
          <p>
            We specialize in connecting brokers with potential clients by
            identifying hot leads. Our process involves discussing aircraft
            details with contacts, understanding their budget and needs, and
            referring them to you if a strong fit is identified. Ready for more
            leads and time-saving solutions? Reach out to us now—don't miss this
            opportunity!
          </p>
          <Button
            className="services-button"
            disableRipple
            component={Link}
            to="/contact"
          >
            Get started
          </Button>
        </div>
        <div className="services-right-container">
          <div className="service-card">
            <div className="service-img-container">
              <img
                className="service-card-icon-container"
                src={LeadsIcon}
                alt="Icon"
              />
            </div>
            <div className="service-card-text-container">
              <h3>Hot Leads</h3>
              <p>
                We deliver high-quality leads directly to you. If the brokers
                are the closers, we act as the appointmentsetters by providing
                numerous interested leads, enhancing your leverage.
              </p>
            </div>
          </div>
          <div className="service-card">
            <div className="service-img-container">
              <img
                className="service-card-icon-container"
                src={StarIcon}
                alt="Icon"
              />
            </div>
            <div className="service-card-text-container">
              <h3>Off-market Exclusivity</h3>
              <p>
                Our service is exclusively with off-market aircraft, ensuring
                confidentiality and providing fresh, unseen options to buyers
                without the risk of on-market exposure.
              </p>
            </div>
          </div>
          <div className="service-card">
            <div className="service-img-container">
              <img
                className="service-card-icon-container"
                src={SheildIcon}
                alt="Icon"
              />
            </div>
            <div className="service-card-text-container">
              <h3>100% Secured</h3>
              <p>
                Working with us carries no risk since we earn only when you do.
                We also prioritize your most valuable asset—time—and our service
                exists to save it for you.
              </p>
            </div>
          </div>
          <div className="service-card">
            <div className="service-img-container">
              <img
                className="service-card-icon-container"
                src={PolicyIcon}
                alt="Icon"
              />
            </div>
            <div className="service-card-text-container">
              <h3>No Deal Involvment Policy</h3>
              <p>
                We focus solely on connecting you with strong fits, ensuring no
                involvement in deal negotiations or closing processes, just
                facilitating a seamless introduction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
